"use strict";

exports.__esModule = true;
exports.Layout = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _ElementRenderer = require("../ElementRenderer");
var _Core = require("../../Core");
var _CurrentClassification = require("../../Timeline/CurrentClassification");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function createStateFromProps(_ref) {
  var widgets = _ref.widgets,
    config = _ref.config,
    x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height,
    updateLayout = _ref.updateLayout;
  var components = {};
  for (var i = 0; i < widgets.length; i++) {
    var widget = widgets[i];
    if (widget.components.Element) {
      components[widget.name] = widget.components.Element;
    }
  }
  return {
    widgets: widgets,
    config: config,
    updateLayout: updateLayout,
    element: Object.assign({}, config.element, {
      props: Object.assign({}, config.element.props, {
        width: width,
        height: height,
        x: x,
        y: y
      })
    }),
    components: components,
    width: width,
    height: height
  };
}

/**
 * Renders a layout based on a configuration object and a list of
 * of widgets.
 */
var Layout = exports.Layout = /*#__PURE__*/function (_Component) {
  function Layout() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = createStateFromProps(_this.props);
    _this.modifyProps = function (props) {
      return Object.assign({}, props, {
        widgets: _this.props.widgets || []
      });
    };
    return _this;
  }
  _inheritsLoose(Layout, _Component);
  Layout.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (props.width === prevState.width && props.height === prevState.height && (0, _reactFastCompare["default"])(props.widgets, prevState.widgets) && (0, _reactFastCompare["default"])(props.config, prevState.config)) {
      return null;
    }
    return createStateFromProps(props);
  };
  var _proto = Layout.prototype;
  _proto.render = function render() {
    var _this$state = this.state,
      components = _this$state.components,
      element = _this$state.element,
      updateLayout = _this$state.updateLayout;
    return /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_CurrentClassification.CurrentClassificationProvider, null, /*#__PURE__*/_react["default"].createElement(_ElementRenderer.ElementRenderer, {
      components: components,
      config: element,
      updateLayout: updateLayout,
      modifyProps: this.modifyProps
    })));
  };
  return Layout;
}(_react.Component);